if (!window.Eurus.loadedScript.has('share-cart.js')) {
  window.Eurus.loadedScript.add('share-cart.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      const root = Shopify.routes.root;
      const encode = data => {
        const bytes = new TextEncoder().encode(JSON.stringify(data));
        return btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join('')).replaceAll('+','-').replaceAll('/','_').replace(/=+$/,'');
      };
      const decode = value => JSON.parse(new TextDecoder('utf-8',{fatal:true}).decode(Uint8Array.from(atob(value.replaceAll('-','+').replaceAll('_','/')), char=>char.charCodeAt(0))));
      const signature = item => JSON.stringify([Number(item.id || item.variant_id), item.selling_plan || item.selling_plan_allocation?.selling_plan?.id || null,
        Object.entries(item.properties || {}).filter(([,v])=>v !== '' && v != null).sort(([a],[b])=>a.localeCompare(b))]);
      Alpine.store('xCartShare', {
        openShareCart:false, cartShareUrl:'', shared:false, copySuccess:false, importing:false,
        policy() { if (!window.InkArtworkOrderPolicy) throw new Error('Artwork validation is unavailable'); return window.InkArtworkOrderPolicy; },
        notice(key) {
          let node=document.getElementById('ink-share-cart-warning');
          if(!node) { node=document.createElement('p');node.id='ink-share-cart-warning';node.setAttribute('role','alert');(document.getElementById('MainContent')||document.body).prepend(node); }
          node.textContent=this.policy().messages[key];
        },
        async generateUrl() {
          this.cartShareUrl='';
          try {
            const cart=await this.policy().readCart();
            if(this.policy().missingArtwork(cart).length) {this.notice('shareInvalid');return;}
            const items=cart.items.map(item=>({id:item.variant_id,handle:item.handle,quantity:item.quantity,properties:item.properties||{},
              ...(item.selling_plan_allocation ? {selling_plan:item.selling_plan_allocation.selling_plan.id} : {})}));
            // Fragments keep uploaded design metadata out of HTTP requests and referrers.
            const payload=encode({version:2,items});
            if(payload.length>24000) {this.notice('shareFailed');return;}
            this.cartShareUrl=window.location.origin+root+'cart#ink-cart='+payload;
          } catch {this.notice('shareFailed');}
        },
        async copyURL() {
          if(!this.cartShareUrl) return;
          try {await navigator.clipboard.writeText(this.cartShareUrl);this.copySuccess=true;setTimeout(()=>this.copySuccess=false,2000);}
          catch {this.notice('copyFailed');}
        },
        async handleShareCart() {
          if(this.importing || this.shared) return;
          if(window.location.search.includes('share_cart:true')) {this.notice('shareInvalid');return;}
          const match=/^#ink-cart=([a-zA-Z0-9_-]+)$/.exec(window.location.hash);
          if(!match) return;
          this.importing=true;
          try {
            if(match[1].length>24000) throw new Error('Invalid shared cart');
            const data=decode(match[1]);
            if(data.version!==2 || !Array.isArray(data.items) || data.items.length<1 || data.items.length>50) throw new Error('Invalid shared cart');
            for(const item of data.items) {
              if(!Number.isSafeInteger(item.id) || item.id<1 || !Number.isInteger(item.quantity) || item.quantity<1 || item.quantity>9999
                || !/^[a-z0-9-]+$/.test(item.handle || '') || !item.properties || Array.isArray(item.properties)
                || Object.entries(item.properties).some(([key,value])=>key.length>255 || typeof value!=='string' || value.length>4096)
                || (item.selling_plan && (!Number.isSafeInteger(item.selling_plan) || item.selling_plan<1))) throw new Error('Invalid shared cart');
            }
            // Resolve each variant against its actual product; never trust a link's label.
            const products=new Map();
            for(const handle of new Set(data.items.map(item=>item.handle))) {
              const response=await fetch(root+'products/'+handle+'.js',{headers:{Accept:'application/json'}});
              if(!response.ok) throw new Error('Product unavailable');
              products.set(handle,await response.json());
            }
            for(const item of data.items) {
              const product=products.get(item.handle);
              if(!product.variants?.some(variant=>variant.id===item.id)) throw new Error('Variant mismatch');
            }
            if(this.policy().missingArtwork({items:data.items}).length) {this.notice('shareInvalid');return;}
            await this.addCartItems(data.items);
            history.replaceState(null,'',window.location.pathname+window.location.search);
          } catch {this.notice('shareFailed');}
          finally {this.importing=false;}
        },
        async addCartItems(items) {
          const helper=Alpine.store('xCartHelper');
          await helper.waitForCartUpdate?.();
          const cart=await this.policy().readCart();
          const desired=new Map();
          for(const item of items) {const key=signature(item);if(desired.has(key)) desired.get(key).quantity+=item.quantity;else desired.set(key,{...item});}
          const existing=new Map();
          for(const item of cart.items) existing.set(signature(item),(existing.get(signature(item))||0)+item.quantity);
          const additions=[...desired.entries()].map(([key,item])=>({...item,quantity:Math.max(0,item.quantity-(existing.get(key)||0))})).filter(item=>item.quantity>0);
          if(additions.length) {
            const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({items:additions.map(({handle,...item})=>item),sections:helper.getSectionsToRender().map(section=>section.id)})});
            if(!response.ok) throw new Error('Cart update failed');
            const result=await response.json();
            helper.reRenderSections(result.sections);
            Alpine.store('xMiniCart')?.openCart();
            const updated=await this.policy().readCart();
            helper.currentItemCount=updated.item_count;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          }
          this.shared=true;
        }
      });
    });
  });
}
